import React from 'react'

export const WarningIcon = (
  color = '#D99F04',
  secondaryColor = '#FDECC7',
  width = 70,
  height = 50
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 70 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.875" cy="16.875" r="1.875" fill={color} />
      <circle cx="65.625" cy="38.125" r="1.875" fill={color} />
      <circle cx="8.125" cy="11.875" r="0.625" fill={color} />
      <circle cx="6.25" cy="28.75" r="1.25" fill={color} />
      <circle cx="63.125" cy="45.625" r="0.625" fill={color} />
      <circle cx="68.75" cy="28.75" r="1.25" fill={color} />
      <rect x="11.25" width={50} height={50} rx={25} fill={secondaryColor} />
      <g clipPath="url(#clip0_5191_9621)">
        <path
          d="M37.8742 13.9351L48.6667 32.6276C48.8313 32.9126 48.9179 33.2359 48.9179 33.565C48.9179 33.8942 48.8313 34.2175 48.6667 34.5025C48.5022 34.7876 48.2655 35.0243 47.9804 35.1888C47.6954 35.3534 47.3721 35.44 47.043 35.4401H25.458C25.1288 35.44 24.8055 35.3534 24.5205 35.1888C24.2354 35.0243 23.9988 34.7876 23.8342 34.5025C23.6696 34.2175 23.583 33.8942 23.583 33.565C23.583 33.2359 23.6696 32.9126 23.8342 32.6276L34.6267 13.9351C35.348 12.6851 37.1517 12.6851 37.8742 13.9351ZM36.2505 28.7501C35.9189 28.7501 35.601 28.8818 35.3666 29.1162C35.1322 29.3506 35.0005 29.6685 35.0005 30.0001C35.0005 30.3316 35.1322 30.6495 35.3666 30.8839C35.601 31.1184 35.9189 31.2501 36.2505 31.2501C36.582 31.2501 36.8999 31.1184 37.1343 30.8839C37.3688 30.6495 37.5005 30.3316 37.5005 30.0001C37.5005 29.6685 37.3688 29.3506 37.1343 29.1162C36.8999 28.8818 36.582 28.7501 36.2505 28.7501ZM36.2505 20.0001C35.9443 20.0001 35.6488 20.1125 35.42 20.316C35.1912 20.5194 35.045 20.7997 35.0092 21.1038L35.0005 21.2501V26.2501C35.0008 26.5687 35.1228 26.8751 35.3415 27.1068C35.5602 27.3384 35.8592 27.4779 36.1772 27.4965C36.4953 27.5152 36.8084 27.4117 37.0528 27.2072C37.2971 27.0027 37.4541 26.7127 37.4917 26.3963L37.5005 26.2501V21.2501C37.5005 20.9185 37.3688 20.6006 37.1343 20.3662C36.8999 20.1318 36.582 20.0001 36.2505 20.0001Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5191_9621">
          <rect
            width={30}
            height={30}
            fill="white"
            transform="translate(21.25 10)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
